import checkSpanishLanguage from "./checkSpanishLanguage";
import ScriptsQuestionTypeToolTips from "./ScriptsQuestionTypeToolTips";
import preChatGreetingTemplate from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/greeting_template.ejs';

const appendGreeting = (wrapper, options) => {
    if (!wrapper || ApexChat.prechatGreetingFlashed) return; // Ensure wrapper exists

    // Select existing greeting div if already present
    const existingGreeting = wrapper.querySelector('.livechat_prechat_greeting');

    // Check if the text is empty or whitespace
    if (!options?.preChatHeaderTemplate?.trim()) {
        // If text is empty and greeting exists, remove it
        if (existingGreeting) {
            existingGreeting.remove();
        }
        return;
    }

    // If text is valid, insert or update greeting
    const preChatGreeting = preChatGreetingTemplate({
        text: options.preChatHeaderTemplate,
    });

    if (existingGreeting) {
        existingGreeting.outerHTML = preChatGreeting; // Replace existing greeting
    } else {
        wrapper.insertAdjacentHTML('afterbegin', preChatGreeting); // Insert new greeting
    }
    ApexChat.prechatGreetingFlashed = true;
};
export default appendGreeting;